import { Box, Tooltip } from "@mui/material";
import { SectionValueView } from "generated/graphql";
import { P } from "theme/typography";
import { SectionValidationIcon, SectionValueIcon } from "../SectionOutcomes";
import { displayOutcomeStatus, displayValidationStatus } from "Backend";
import { useAppSelector } from "redux/hooks";
import { selectLensOutcomeStatusConfiguration } from "redux/slices/clientLens";
import theme, { EllipsisSX } from "theme";

interface CaseHitsBreadcrumbsProps {
  allCategoriesClick: () => void;
  activeCategory: string;
  titleText: string;
  currentSection?: SectionValueView;
}

const CaseHitsBreadcrumbs = ({
  allCategoriesClick,
  activeCategory,
  titleText,
  currentSection,
}: CaseHitsBreadcrumbsProps) => {
  const { lensOutcomeStatusConfigurations, sbrEnabled } = useAppSelector(selectLensOutcomeStatusConfiguration);

  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "flex-start",
        gap: 1,
        minWidth: 0,
      }}>
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          minWidth: 0,
        }}>
        {currentSection ? (
          <Box
            sx={{
              display: "flex",
              mr: 1,
            }}>
            <Tooltip
              title={displayOutcomeStatus(currentSection?.outcomeStatus, sbrEnabled, lensOutcomeStatusConfigurations)}
              arrow>
              <Box sx={{ display: "flex", alignItems: "center" }}>
                <SectionValueIcon
                  outcomeStatus={currentSection?.outcomeStatus}
                  sx={{ borderColor: theme.palette.grey[900] }}
                />
              </Box>
            </Tooltip>
            <Tooltip title={displayValidationStatus(currentSection?.validationStatus)} arrow>
              <Box sx={{ ml: 1, display: "flex", alignItems: "center" }}>
                <SectionValidationIcon
                  status={currentSection?.validationStatus}
                  sx={{ borderColor: theme.palette.grey[900] }}
                />
              </Box>
            </Tooltip>
          </Box>
        ) : (
          <></>
        )}
        <P
          variant="xs"
          onClick={allCategoriesClick}
          sx={{
            ...theme.mixins.linkLike,
            overflow: "hidden",
            textOverflow: "ellipsis",
            whiteSpace: "nowrap",
          }}>
          {titleText}
        </P>
      </Box>
      <Box>
        <P
          variant="xs"
          sx={{
            color: theme.palette.grey[3],
          }}>
          /
        </P>
      </Box>
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          minWidth: 0,
        }}>
        <P
          variant="xs"
          sx={{
            ...EllipsisSX,
          }}>
          {activeCategory}
        </P>
      </Box>
    </Box>
  );
};

export default CaseHitsBreadcrumbs;
